import localStorageDataProvider from "ra-data-local-storage";
import mockData from "./mock-data.json";

const fakeDataProvider = localStorageDataProvider({
  defaultData: mockData,
});

export default fakeDataProvider;
